import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext"; // Adjust the path as necessary
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Make sure this import is correct based on your file structure

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [mobileSubmitted, setMobileSubmitted] = useState(false);
  const [otpStatusMessage, setOtpStatusMessage] = useState("");
  const [timer, setTimer] = useState(0); // Timer state
  const [canSendOtp, setCanSendOtp] = useState(true); // Control the ability to send OTP
  const { isLoggedIn, login } = useAuth();
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    let interval = null;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanSendOtp(true); // Re-enable the ability to send OTP
      setMobileSubmitted(false); // Reset mobileSubmitted to allow resending OTP
      setOtpStatusMessage(""); // Optionally, clear the status message
      clearInterval(interval);
    }

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [timer]);

  const requestOtp = async () => {
    if (mobile.length !== 10 || isNaN(mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (!canSendOtp) return; // Prevent sending OTP if the timer is active

    try {
      setOtpStatusMessage("Sending OTP... Please wait.");
      await axios.post(`${process.env.REACT_APP_API_URL}/login`, { mobile });
      setMobileSubmitted(true);
      setOtpStatusMessage(
        "OTP has been sent on Whatsapp and SMS. Kindly wait for 10 to 20 seconds."
      );
      setCanSendOtp(false); // Disable the ability to send another OTP
      setTimer(60); // Start the countdown from 30 seconds
    } catch (error) {
      console.error("Error requesting OTP:", error);
      // Handle specific error for mobile number not found
      if (error.response && error.response.status === 404) {
        setOtpStatusMessage(error.response.data);
      } else {
        alert("Failed to send OTP. Please try again.");
      }
      // setOtpStatusMessage('');
    }
  };

  const verifyOtp = async () => {
    try {
      // Send OTP back to the backend for verification
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify`,
        { mobile, otp }
      );
      if (response.data.success) {
        console.log("OTP is correct");
        login(mobile, "customer"); // Update login state
        navigate("/customer-dashboard"); // Navigate to invoices page
      } else {
        console.log("OTP is not correct");
        alert("Incorrect OTP. Please try again.");
        setOtp(""); // Clear the OTP input field
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("OTP verification failed. Please try again.");
      setOtp(""); // Clear the OTP input field
    }
  };

  // Redirect user if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/customer-dashboard");
    }
  }, [isLoggedIn, navigate]); // Dependency array to re-run effect if isLoggedIn changes

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h1>Customer Login</h1>
        <p>Please enter your WhatsApp number to receive an OTP.</p>
        <div className="form-row">
          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter WhatsApp number"
            className="form-control"
            maxLength="10"
            readOnly={!canSendOtp || mobileSubmitted}
          />
          <button onClick={requestOtp} className="btn" disabled={!canSendOtp}>
            Send OTP
          </button>
        </div>
        {otpStatusMessage && (
          <p className="otp-status-message">{otpStatusMessage}</p>
        )}
        {!canSendOtp && <p className="timer">Resend OTP in {timer} seconds</p>}
        <div className="form-row">
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            className="form-control"
          />
          <button onClick={verifyOtp} className="btn">
            Verify OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
